import React from 'react';

export const ClientCarousel = ({
    title = "Our Clientele",
    logos = []
}) => {
    if (logos.length === 0) {
        return null; // Don't render if no logos provided
    }

    // Create extended array for infinite scroll effect
    const extendedLogos = [...logos, ...logos, ...logos];

    return (
        <div className="w-full py-4">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Title */}
                <h2 className="text-4xl md:text-3xl lg:text-6xl ultrapure_heading mb-4">
                    {title}
                </h2>

                {/* Carousel Container with Grey Background and Shadow */}
                <div className="relative py-4 overflow-hidden">

                    {/* Scrolling Container */}
                    <div className="overflow-hidden">
                        <div
                            className="flex gap-8 lg:gap-12 animate-scroll pb-10 pt-4"
                            style={{
                                width: `${extendedLogos.length * 140}px`,
                                animation: `scroll ${50}s linear infinite`
                            }}
                        >
                            {extendedLogos.map((logo, index) => (
                                <div
                                    key={`${logo.id || logo.name}-${index}`}
                                    className="flex-shrink-0 bg-[#D9D9D926] rounded-full w-24 h-24 lg:w-36 lg:h-36  hover:shadow-lg hover:rounded-full  transition-all duration-300 transform hover:scale-105 flex items-center justify-center p-4"
                                >
                                    <img
                                        src={logo.src || logo.image || logo.logo}
                                        alt={logo.alt || logo.name || 'Client logo'}
                                        className="max-w-full max-h-full object-contain filter transition-all duration-600"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Gradient Overlays for smooth edges */}
                    {/* <div className="absolute left-0 top-0 w-20 h-full bg-gradient-to-r from-gray-100 to-transparent z-10 pointer-events-none"></div>
          <div className="absolute right-0 top-0 w-20 h-full bg-gradient-to-l from-gray-200 to-transparent z-10 pointer-events-none"></div> */}
                </div>

            </div>

            {/* CSS Animation */}
            <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-${logos.length * 140}px);
          }
        }
        
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
        </div>
    );
};

// Example usage
const ClientCarouselDemo = () => {
    const clientLogos1 = [
        { name: "", src: "./logo/1 (1).png", alt: " Logo" },
        { name: "", src: "./logo/1 (2).png", alt: " Logo" },
        { name: "", src: "./logo/1 (3).png", alt: " Logo" },
        { name: "", src: "./logo/1 (4).png", alt: " Logo" },
        { name: "", src: "./logo/1 (5).png", alt: " Logo" },
        { name: "", src: "./logo/1 (6).png", alt: " Logo" },
        { name: "", src: "./logo/1 (7).png", alt: " Logo" },
        { name: "", src: "./logo/1 (8).png", alt: " Logo" },
        { name: "", src: "./logo/1 (9).png", alt: " Logo" },
        { name: "", src: "./logo/1 (10).png", alt: " Logo" },
        { name: "", src: "./logo/1 (11).png", alt: " Logo" },
        { name: "", src: "./logo/1 (12).png", alt: " Logo" },
        { name: "", src: "./logo/1 (13).png", alt: " Logo" },
        { name: "", src: "./logo/1 (14).png", alt: " Logo" },
        { name: "", src: "./logo/1 (15).png", alt: " Logo" },
        { name: "", src: "./logo/1 (16).png", alt: " Logo" },
        { name: "", src: "./logo/1 (17).png", alt: " Logo" },
        { name: "", src: "./logo/1 (18).png", alt: " Logo" },
        { name: "", src: "./logo/1 (19).png", alt: " Logo" },
        { name: "", src: "./logo/1 (20).png", alt: " Logo" },
        { name: "", src: "./logo/1 (21).png", alt: " Logo" },
        { name: "", src: "./logo/1 (22).png", alt: " Logo" },
        { name: "", src: "./logo/1 (23).png", alt: " Logo" },
    ];

    const clientLogos2 = [
        { name: "", src: "./tested/1 (1).png", alt: "" },
        { name: "", src: "./tested/1 (2).png", alt: "" },
        { name: "", src: "./tested/1 (3).png", alt: "" },
        { name: "", src: "./tested/1 (4).png", alt: "" },
        { name: "", src: "./tested/1 (5).png", alt: "" },
        { name: "", src: "./tested/1 (6).png", alt: "" },
        { name: "", src: "./tested/1 (7).png", alt: "" },
        { name: "", src: "./tested/1 (8).png", alt: "" },
        { name: "", src: "./tested/1 (9).png", alt: "" },
        { name: "", src: "./tested/1 (10).png", alt: "" },
        { name: "", src: "./tested/1 (11).png", alt: "" },

    ];

    return (
        <div className="py-10">
            {/* First Carousel */}
            <ClientCarousel
                title="Our Clientele"
                logos={clientLogos1}
            />

            {/* Second Carousel */}
            <ClientCarousel
                title="Our Certifications   "
                logos={clientLogos2}
            />
        </div>
    );
};

export default ClientCarouselDemo;